/* disable-variant-autoscroll.js — v3 "Zero-Jump"
   Deaktiviert sichtbares Scrollen/Ankern beim Variantenwechsel (Dawn + Globo + Custom).
   Blockt für ein kurzes Zeitfenster scrollTo/scrollIntoView/focus + Medien-Hashes.
*/
(function () {
  const MEDIA_HASHES = ['#media-', '#Slide-', '#Image', '#zoom', '#Gallery'];
  const VARIANT_SELECTORS = [
    'variant-radios', 'variant-selects',
    '.globo-swatches', '.globo-option', '.globo-variant', '.globo-product-options',
    '.product-variants', 'form[action*="/cart/add"]'
  ];

  function isMediaHash(h) {
    const x = (h || location.hash || '').toString();
    return MEDIA_HASHES.some(p => x.startsWith(p));
  }

  function clearHashPreserveScroll() {
    const x = window.pageXOffset, y = window.pageYOffset;
    try { history.replaceState('', document.title, location.pathname + location.search); } catch(e) {}
    window.scrollTo(x, y);
  }

  // ===== Scroll/Fokus-Blocker-Fenster =====================================
  let guardTimer = null;
  let guardUntil = 0;

  function startGuardWindow(ms = 2000) {
    guardUntil = Date.now() + ms;
    if (guardTimer) clearInterval(guardTimer);

    // während des Fensters wiederkehrend Hash bereinigen
    guardTimer = setInterval(() => {
      if (Date.now() > guardUntil) {
        clearInterval(guardTimer);
        guardTimer = null;
      } else if (isMediaHash(location.hash)) {
        clearHashPreserveScroll();
      }
    }, 50);
  }

  function inGuard() {
    return Date.now() <= guardUntil;
  }

  // ===== Patches: scrollTo / scrollIntoView / focus =======================
  // 1) window.scrollTo guard
  try {
    const origScrollTo = window.scrollTo;
    window.scrollTo = function () {
      if (inGuard()) return; // unterbinden
      return origScrollTo.apply(this, arguments);
    };
  } catch (e) {}

  // 2) Element.scrollIntoView guard (nur für Gallerie/Produktcontainer)
  try {
    const origSIV = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (inGuard()) {
        // für Produktmedien oder innerhalb des Produktbereichs gar nicht scrollen
        const el = this;
        if (
          el.closest('media-gallery, product-media-gallery, product-info, .product, .product__media-wrapper, .product__media, .product__media-list')
        ) return;
      }
      return origSIV.apply(this, arguments);
    };
  } catch (e) {}

  // 3) Element.focus guard (verhindert implizites Scrollen durch Fokus)
  try {
    const origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (opts) {
      if (inGuard()) {
        // Fokus ohne Scroll
        try { return origFocus.call(this, { ...(opts||{}), preventScroll: true }); }
        catch(e) { /* fallback ohne Optionen */ return origFocus.call(this); }
      }
      return origFocus.call(this, opts);
    };
  } catch (e) {}

  // ===== Hash-Change sofort neutralisieren ================================
  window.addEventListener('hashchange', () => {
    if (isMediaHash(location.hash)) clearHashPreserveScroll();
  }, true);

  // ===== Hooks für Variantenwechsel (Dawn + Globo) =======================
  function hookVariantEvents() {
    const sel = VARIANT_SELECTORS.join(',');
    ['change', 'click'].forEach(evt => {
      document.addEventListener(evt, (e) => {
        const t = e.target;
        if (!t) return;
        if (t.closest(sel)) {
          startGuardWindow(2500); // 2.5s Schutzfenster
        }
      }, true); // capture früh
    });
  }

  // ===== Dawn custom elements ruhigstellen ================================
  function patchDawnMediaGallery() {
    try {
      const MG = customElements.get('media-gallery') || customElements.get('product-media-gallery');
      if (MG && MG.prototype) {
        ['setActiveMedia', 'setActiveMediaId'].forEach(m => {
          if (typeof MG.prototype[m] === 'function') {
            const orig = MG.prototype[m];
            MG.prototype[m] = function () {
              const x = window.pageXOffset, y = window.pageYOffset;
              startGuardWindow(2500);
              const res = orig.apply(this, arguments);
              // Position halten
              window.scrollTo(x, y);
              return res;
            };
          }
        });
      }
    } catch (e) {}
  }

  // ===== Initial ==========================================================
  document.addEventListener('DOMContentLoaded', () => {
    hookVariantEvents();
    patchDawnMediaGallery();
    if (isMediaHash(location.hash)) clearHashPreserveScroll();
  });

  // Falls App/Theme extrem früh setzt:
  if (isMediaHash(location.hash)) clearHashPreserveScroll();
})();
